import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import AddImage from '../../../components/reusable/images/add-image/add-image.component';
import SectionDisplay from '../../../components/content-management/sections/displays/section-display.component.jsx';
import Spinner from '../../../components/reusable/spinner/spinner.component';
import UpdateSection from '../../../components/content-management/sections/update/update-section.component';

import Client from '../../../tools/client';
import { admin } from '../../../config.js';

import {
    BackLink,
    ContentContainer,
    MainContainer,
    MainTitle,
    Text
} from '../../../styles/page.styles';

const client = new Client();

const CMSSection = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [ loading, setLoading ] = useState(true);
    const [ showUpdate, setShowUpdate ] = useState(false);
    const [ section, setSection ] = useState('');

    useEffect(() => {
        getSection();

        // eslint-disable-next-line
    }, []);

    const getSection = async () => {
        setLoading(true);
        const res = await client.getSectionById(id);

        setSection(res);
        setLoading(false);
    }

    const updateSection = async (data) => {
        await client.updateSection(section.id, data);
        await getSection();
        setShowUpdate(false);
    }

    const deleteSection = async () => {
        await client.deleteSection(id);
        navigate(`/content-management/pages/${section.pageId}`);
    }

    const display = () => {
        if(showUpdate) {
            return (<UpdateSection section={section} showUpdate={setShowUpdate} deleteSection={deleteSection} submit={updateSection} />)
        }

        return (
            <SectionDisplay section={section} getSection={getSection} setShowUpdate={setShowUpdate} />
        )
    }

    return (
        <MainContainer>
            <BackLink onClick={() => navigate(`/content-management/pages/${section.pageId}`)}>
                Back To Page
            </BackLink>
            {loading ?
                <Spinner />
            :
                section.length === 0 ?
                    <MainTitle>No Section to Display</MainTitle>
                :
                    display()
            }
        </MainContainer>
    )
}

export default CMSSection;